<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MhEcEn/tc-custom/9781452150451.jpg?1705006395737" alt="This image is the cover for the book Grill Eats & Drinks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grill Eats & Drinks
      </h1>
      <p class="bookDescription body article font2">
        <b>The essential recipes you need to establish the best grilling game on the block—from Grilled Pizza to Foolproof Burgers, Tequila-Lime Shrimp to Mojitos.</b><br/>  <br/> A taste of the good life! This bite-size collection showcases twenty special recipes, all with photographs, that will inspire food lovers to take the party outside. Selected from some of Chronicle Books’ best-loved cookbooks, here are easy-peasy drinks (alcoholic and nonalcoholic), quick appetizers, simple salads and sides, and great-for-the-grill main dishes. Whether it’s the South Seas Sangria, Corn with Chipotle Butter, or the Honey-Glazed Spareribs that beckon, everything tastes better out on the patio. And grilling will be all the more relaxing for the cook who has this just-right repertoire at hand. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chronicle Books
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6fc9658c